<script lang="ts">
import { CSSProperties, defineComponent, PropType } from 'vue';
import { generateId } from '@/utils/utils';

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'CGrid',
	props: {
		list: {
			required: true,
      type: null as unknown as PropType<Array<Record<string, string>> | null>,
      validator: (v: never) => Array.isArray(v) || v === null,
		},
		label: {
			required: false,
			type: String,
			default: () => '',
		},
		itemWidth: {
			required: false,
			type: String,
			default: '',
		},
		itemHeight: {
			required: false,
			type: String,
			default: '',
		},
		itemMarginRight: {
			required: false,
			type: String,
			default: '',
		},
		itemMarginBottom: {
			required: false,
			type: String,
			default: '',
		},
		hasDividerStart: {
			required: false,
			type: Boolean,
			default: false,
		},
		hasDividerEnd: {
			required: false,
			type: Boolean,
			default: false,
		},
		gridStyle: {
			required: false,
			type: Object as PropType<CSSProperties>,
			default: () => ({}),
		},
	},
	setup() {
		return {
			id: String(generateId()),
		};
	},
});
</script>

<template>
	<div
		v-if="list?.length"
		class="flex-column"
	>
		<hr v-if="hasDividerStart">

		<slot
			v-if="label"
			:id="id"
			name="label"
		>
			<label
				class="c-gird__label mb-16"
				:for="id"
			>
				{{ label }}
			</label>
		</slot>

		<div
			:id="id"
			class="c-grid__grid"
			:style="{
				marginRight: `-${itemMarginRight}`,
				marginBottom: `-${itemMarginBottom}`,
				...gridStyle,
			}"
		>
			<span
				v-for="item in list"
				:key="JSON.stringify(item)"
				:style="{
					width: itemWidth,
					height: itemHeight,
					marginRight: itemMarginRight,
					marginBottom: itemMarginBottom,
				}"
			>
				<slot
					name="item"
					:item="item"
				/>
			</span>
		</div>
	</div>

	<hr v-if="hasDividerEnd">
</template>

<style scoped lang="scss">
.c-gird__label {
	@include tools.font-size(12px, 14px);

	color: tokens.$color-gray-aa;
	font-weight: 600;
	text-transform: uppercase;
}

.c-grid__grid {
	display: flex;
	flex-wrap: wrap;
}
</style>
